module.exports = __webpack_public_path__ + "static/a-couple-sitting-and-watching-the-sunset.60837ac2.webp";